import React from 'react'
import EventsCard from '../components/Main/EventsCard'

import CtaBanner from '../components/Main/CtaBanner'
import Page from '../components/Page'

export default function Events (props) {
  const {
    //Hero Section fields
    intro_image: {
      url: introImage,
      alt: alt,
      height: height,
      width: width,
      id: imageId
    },
    intro_heading: introHeading,
    intro_paragraph: introParagraph,
    image_side: imageSide,

    //Events Repeater
    events: eventsFields,

    //CtaBanner Fields
    cta_heading: ctaHeading,
    cta_link: { url: ctaLink, title: ctaButton }
  } = props.acf

  return (
    <React.Fragment>
      <Page
        title={introHeading}
        body={introParagraph}
        bgImage={introImage}
        bgId={imageId}
        alt={alt}
        left={imageSide === 'left' ? true : false}
        height={height}
        width={width}
        slug={'/events'}
      >
        <main id='content' className='events-page'>
          <EventsCard events content={eventsFields} />
        </main>

        <CtaBanner title={ctaHeading} link={ctaLink} button={ctaButton} />
      </Page>
    </React.Fragment>
  )
}
